<app-property-information [propertyData]=""></app-property-information>
<!-- <app-comparable-sales [salesData]="jsonData.SalesComparables"></app-comparable-sales>
<app-comparable-rents [rentsData]="jsonData.RentComparables"></app-comparable-rents> -->
<!-- <div class="">
    <mat-tab-group>
        <mat-tab>
            <app-property-information [propertyData]=""></app-property-information>
        </mat-tab>
    </mat-tab-group>
</div> -->